import { ObjectId } from 'mongoose'
import { Agents, MongooseModel, UploadType } from '.'

export type DocHistory = {
  timestamp: Date
  status: string
  comments?: string
  by: ObjectId
}

export interface UploadedDoc {
  containerName: string
  blobName: string
  label?: string // original file name
  contentType: string
}

export interface SolarDoc extends UploadedDoc {
  _id?: string
  abrigoId?: number
  history?: DocHistory[]
}

export enum AgentDocResult {
  Deny = 'deny',
  AwaitingQuestion = 'awaiting_question',
  Approve = 'approve',
  Running = 'running',
  Error = 'error'
}

export enum SolarDocStatus {
  Submitted = 'submitted',
  Review = 'review',
  Accepted = 'accepted',
  Comments = 'comments',
  Approved = 'approved',
  PendingUpload = 'pending',
  Uploaded = 'uploaded'
}

export interface LoanDocument extends SolarDoc {
  status?: SolarDocStatus
  comments?: string // these will be the most recent comments
  agentComments?: string // these will be the most recent comments from the agent
  agentResult?: AgentDocResult
  agentWorkflowRuns?: Agents.IWorkflowRun[]
  agentError?: string
  workflowId?: string
  installerResponse?: string
  docType?: string
}

export type LoggedUpload = {
  uploadType: UploadType
  timestamp: Date
  uploadedBy?: string
  documents: LoanDocument[]
  notes?: string
} & MongooseModel

// for status email
export type BlobDownload = {
  buffer: Buffer
  contentType: string
}

export type LoanDocumentWithContent = LoanDocument & { content?: BlobDownload }


